import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getBonusesHistory = (params) => {
    return axios.get(`${backendHost}/api/admin/bonuses/history/list`, {params});
};

export {
    getBonusesHistory
}